import { useMutation } from '@tanstack/react-query';
import { updateEducationHistory } from 'src/shared/services/fn-api/Beneficiary';

export const useUpdateEducationHistory = () => {
  return useMutation<Record<string, unknown>, Error, Record<string, unknown>>({
    mutationFn: async (data) => {
      return updateEducationHistory(data);
    },
  });
};
